import React, { FunctionComponent } from 'react';
import { RecruitmentShowContentScoutMessageProps } from './types';
import { RecruitmentShowContentScoutMessageModal } from '../../molecules/recruitmentShowContentScoutMessageModal';

type Props = & RecruitmentShowContentScoutMessageProps & {
  scoutMessagePlain: string;
  scoutMessageLinked: string;
  isModalOpen: boolean;
  handleMoreClick: () => void;
  handleCloseModal: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  dataCategory,
  dataValue,
  scoutMessagePlain,
  scoutMessageLinked,
  isModalOpen,
  handleMoreClick,
  handleCloseModal,
}) => {
  return (
    <>
      <div
        className="recruitment__show__scout-message gtm-scout-view-count"
        data-event-name='scout on screen'
        data-category={dataCategory}
        data-value={dataValue.scoutMessage}
        data-recruitmentId={recruitmentId}
        data-companyId={companyId}
      >
        <div className="recruitment__show__scout-message__content">
          <h3 className="scout-title">スカウトを受けとっています</h3>
          <div className="scout-text" dangerouslySetInnerHTML={{ __html: scoutMessagePlain }} />
          <div className="scout-more">
            <div
              className="scout-more__button gtm-button-view-count"
              data-event-name='button on screen'
              onClick={handleMoreClick}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.moreScoutMessage}
            >
              全文を表示する
            </div>
          </div>
        </div>
      </div>
      <RecruitmentShowContentScoutMessageModal
        isOpen={isModalOpen}
        scoutMessageLinked={scoutMessageLinked}
        onClose={handleCloseModal}
      />
    </>
  );
};
